import gql from 'graphql-tag'

export const VALIDATE_USER_EMAIL = gql`
mutation ($input: ValidateUserEmailInput!) {
  validateUserEmail(input: $input) {
    valid
    errors
  }
}
`

export default {
  VALIDATE_USER_EMAIL
}
